import { lazyLoad } from 'utils/loadable';

export const CreateAccountPage = lazyLoad(
  () => import('./CreateAccountPage'),
  module => module.CreateAccountPage,
);
